import script from "./MainMenuDropdown.vue?vue&type=script&lang=js"
export * from "./MainMenuDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/valdisaglonietis/PhpstormProjects/news_site/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"MainMenuDropdown.vue"]])

export default __exports__